import React from 'react';

const QuestionAnswer = ({ lead }) => {
	return (
		<div className='questionAnswerDetails'>
			<div className='questionAndAnswers'>
				<p className='profileLinkHead'>Questions & Answers</p>
				<div className='questionAndAnswerContent'>
					<span className='questionsSpan'>
						<span className='questionNumbering'>Q</span>
						<span className='questionContent'>{lead.question1}</span>
					</span>
					<span className='answerSpan'>
						<span className='answerNumbering'>A</span>
						<span className='answerContent'>{lead.answer1}</span>
					</span>
				</div>
				<div className='questionAndAnswerContent'>
					<span className='questionsSpan'>
						<span className='questionNumbering'>Q</span>
						<span className='questionContent'>{lead.question2}</span>
					</span>
					<span className='answerSpan'>
						<span className='answerNumbering'>A</span>
						<span className='answerContent'>{lead.answer2}</span>
					</span>
				</div>
				<div className='questionAndAnswerContent'>
					<span className='questionsSpan'>
						<span className='questionNumbering'>Q</span>
						<span className='questionContent'>{lead.question3}</span>
					</span>
					<span className='answerSpan'>
						<span className='answerNumbering'>A</span>
						<span className='answerContent'>{lead.answer3}</span>
					</span>
				</div>
			</div>
			<p className='profileLinkHead'>Extra Information</p>
			<p className='questionAnswerTexts'>
				{lead.extraInformation.split(',').map((info, m) => {
					return (
						<li key={m} className='extraInfoLi'>
							{info}
						</li>
					);
				})}
			</p>
		</div>
	);
};

export default QuestionAnswer;
